import {Notification, Paragraph} from '@constellation/core';
import {memo} from 'react';
import {
  JOURNEY_EVENT,
  TAGGING_FIELDS,
} from '../../../../enums/tagging/index.js';
import {BoxFormWrapper, Div} from '../../../../styles/common.js';
import {ROUTE_PATHS} from '../../../../utils/constants/public/psr.js';
import getPsrLabel from '../../../../utils/getPsrLabel.js';
import {QuoteSummaryButtons} from '../../../common/Analytics/Tagging/index.js';
import JourneyHeader from '../../../common/JourneyHeader/JourneyHeader.js';
import {NotificationWrapper} from './styles.js';

const DeclineToQuote = memo(() => (
  <Div bgColor='neutral2' data-testid='declineQuote'>
    <JourneyHeader isNotShownStepCounter={true} />
    <BoxFormWrapper bgColor='none' marginLeft='none'>
      <NotificationWrapper>
        <Notification
          heading={getPsrLabel('declineToQuote.notification.heading')}
          headingLevel={2}
          marginBottom='07'
          marginTop='07'
        >
          <Paragraph marginBottom='none'>
            {getPsrLabel('declineToQuote.notification.body')}
          </Paragraph>
        </Notification>
      </NotificationWrapper>
      <QuoteSummaryButtons
        aria-label={getPsrLabel('declineToQuote.returnToCardnetSrText')}
        data-testid='declineButton'
        eventAction={JOURNEY_EVENT.PAGE_SUBMIT}
        fieldName={TAGGING_FIELDS.APPLY_NOW}
        href={ROUTE_PATHS.CARDNET_LANDING_PAGE}
        journeyAction={JOURNEY_EVENT.PAGE_SUBMIT}
        journeyEvent={JOURNEY_EVENT.INTERNAL_CLICK}
        linkValue='button/returntocardnet'
        taggingLabel={TAGGING_FIELDS.DECLINE_RETURN_TO_CARDNET}
      >
        {getPsrLabel('declineToQuote.returnToCardnet')}
      </QuoteSummaryButtons>
    </BoxFormWrapper>
  </Div>
));

export default DeclineToQuote;
